import React, { useState } from "react";
import styled from "styled-components";
import SegmentedPicker from "../../../ui/SegmentedPicker/SegmentedPicker";

export const LevelSelectorFC = (props) => {
  const [level, setLevel] = useState(1);

  const onChangeLevel = (value) => {
    setLevel(value);
    props.level(value);
  };

  const levelOptions = [
    { eventKey: 1, label: "1" },
    { eventKey: 2, label: "2" },
    { eventKey: 3, label: "3" },
    { eventKey: 4, label: "All" },
  ];

  return (
    <LevelSelectorSC>
      <Label>Parameter Filter Level</Label>
      <SegmentedPicker
        options={levelOptions}
        activeKey={level}
        onSelect={onChangeLevel}
        size="small"
        variant="subtle"
      />
    </LevelSelectorSC>
  );
};

const LevelSelectorSC = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: 768px) {
    padding: 0.75rem;
    gap: 8px;
  }
`;

const Label = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #5d6d7e;
  text-align: center;
  letter-spacing: 0.3px;

  @media screen and (max-width: 768px) {
    font-size: 13px;
  }
`;
